import { flow } from 'lodash';
const addBaseAbilities = ({ embedUser, dashboardUuid, organization, builder, }) => {
    const { can } = builder;
    can('view', 'Dashboard', {
        dashboardUuid,
        organizationUuid: organization.organizationUuid,
    });
    return { embedUser, dashboardUuid, organization, builder };
};
const exportAbilities = ({ embedUser, dashboardUuid, organization, builder, }) => {
    const { content } = embedUser;
    const { can } = builder;
    if (content.canExportCsv) {
        can('export', 'Dashboard', {
            organizationUuid: organization.organizationUuid,
            type: 'csv',
        });
    }
    if (content.canExportPagePdf) {
        can('export', 'Dashboard', {
            organizationUuid: organization.organizationUuid,
            type: 'pdf',
        });
    }
    if (content.canExportImages) {
        can('export', 'Dashboard', {
            organizationUuid: organization.organizationUuid,
            type: 'images',
        });
    }
    return { embedUser, dashboardUuid, organization, builder };
};
const dashboardAbilities = ({ embedUser, dashboardUuid, organization, builder, }) => {
    const { content } = embedUser;
    const { can } = builder;
    can('view', 'Dashboard', {
        dateZoom: content.canDateZoom ?? false,
        organizationUuid: organization.organizationUuid,
    });
    return { embedUser, dashboardUuid, organization, builder };
};
const applyAbilities = flow(addBaseAbilities, exportAbilities, dashboardAbilities);
export function applyEmbeddedAbility(embedUser, dashboardUuid, organization, builder) {
    applyAbilities({ embedUser, dashboardUuid, organization, builder });
}
//# sourceMappingURL=jwtAbility.js.map